import { ref, onMounted, nextTick } from 'vue';
import DOMPurify from 'dompurify'

/**
	* convertNewlinesDirective
	* This converts \n to <br> in the DOM after sanitizing with DOMPurify
	* @allowed br
*/
export const convertNewlinesDirective = {
	mounted(el, binding) {
		const sanitizedValue = DOMPurify.sanitize(binding.value, { ALLOWED_TAGS: ['br', 'a'] });
		el.innerHTML = sanitizedValue.replace(/\n/g, '<br>');
	},
	updated(el, binding) {
		const sanitizedValue = DOMPurify.sanitize(binding.value, { ALLOWED_TAGS: ['br', 'a'] });
		el.innerHTML = sanitizedValue.replace(/\n/g, '<br>');
	},
}